import React, { useState, useEffect } from "react";
import { getHeadsetNameErrors } from "../helpers/helpers.tsx"; // Can reuse or rename helper if needed
import apiFetch, { getCountries } from "../helpers/requests.tsx";
import { useTranslation } from "react-i18next";

const CreateHospitalModal = ({
  setShowCreateHospitalModal,
  headquarterId,
  handleCreateHospital,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedHospitalName, setSelectedHospitalName] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countries, setCountries] = useState<any[]>([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const countryList = await getCountries();
    countryList.sort((a: any, b: any) =>
      t("country_" + a.code).localeCompare(t("country_" + b.code))
    );
    setCountries(countryList);
  };

  const createHospital = async (
    name: string,
    country: string,
    headquarterId: string | undefined
  ) => {
    try {
      const data = await apiFetch(`/createHospital`, {
        method: "POST",
        body: JSON.stringify({ name, country, headquarterId }),
      });
      return data;
    } catch (error) {
      console.error("Error creating hospital:", error);
      throw new Error("An error occurred while create hospital");
    }
  };

  const handleCreateHospitalSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    setFormSubmitted(true);

    // Reusing headset name validation or create new one if specific rules apply
    if (getHeadsetNameErrors(selectedHospitalName, t) || selectedCountry === "") {
      return;
    }

    const newHospital = await createHospital(
      selectedHospitalName,
      selectedCountry,
      headquarterId
    );

    handleCreateHospital(newHospital);
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div style={{ textAlign: "center", fontSize: "1.3em" }}>
          {t("Create_new_hospital")}
        </div>
        <form onSubmit={handleCreateHospitalSubmit} className="m-4">
          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label
              htmlFor="hospitalNameInput"
              style={{
                marginLeft: "20px",
                color: "#404040",
                fontWeight: "bold",
              }}
            >
              {t("Hospital_Name")}
            </label>
            <input
              type="text"
              className="form-control"
              id="hospitalNameInput"
              placeholder={t("Hospital")}
              value={selectedHospitalName}
              onChange={(e) => {
                setSelectedHospitalName(e.target.value);
                setFormSubmitted(false);
              }}
              style={{
                backgroundColor: "#CCCCCC",
                borderRadius: "20px",
                color: "#404040",
                height: "5vh",
                maxHeight: "40px",
                fontSize: "1em",
                paddingLeft: "20px",
              }}
            />
            <label
              htmlFor="hospitalNameInput"
              style={{
                marginLeft: "20px",
                color: "#A63939",
                fontSize: "0.8em",
                visibility:
                  formSubmitted && getHeadsetNameErrors(selectedHospitalName, t)
                    ? "visible"
                    : "hidden",
              }}
            >
              {getHeadsetNameErrors(selectedHospitalName, t)}
            </label>
          </div>

          <div className="mb-3" style={{ marginTop: "2vh" }}>
            <label
              htmlFor="countrySelect"
              style={{
                marginLeft: "20px",
                color: "#404040",
                fontWeight: "bold",
              }}
            >
              {t("Country")}
            </label>
            <select
              id="countrySelect"
              className="form-control"
              style={{
                backgroundColor: "#CCCCCC",
                borderRadius: "20px",
                color: "#404040",
                height: "5vh",
                maxHeight: "40px",
                fontSize: "1em",
                paddingLeft: "20px",
              }}
              value={selectedCountry}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setFormSubmitted(false);
              }}
            >
              <option value=""></option>
              {countries.map((country: any) => (
                <option key={country.id} value={country.id}>
                  {t("country_" + country.code)}
                </option>
              ))}
            </select>
            <label
              htmlFor="countrySelect"
              style={{
                marginLeft: "20px",
                color: "#A63939",
                fontSize: "0.8em",
                visibility:
                  formSubmitted && selectedCountry === ""
                    ? "visible"
                    : "hidden",
              }}
            >
              {t("Country_is_required")}
            </label>
          </div>

          <div className="button-container">
            <button
              type="button"
              className="buttonCancel btn btn-primary"
              onClick={() => setShowCreateHospitalModal(false)}
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary buttonAcceptGreen"
              disabled={formSubmitted}
            >
              {t("Create")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateHospitalModal;